import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight, FiCheckCircle } from 'react-icons/fi';
import { stats } from '../data/site';

const fadeUp = (delay = 0) => ({
  initial: { y: 16 },
  animate: { y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }
});

const chartBars = [42, 58, 50, 72, 64, 86, 78];

// Illustrative product UI: a school management dashboard, built in HTML/CSS.
// TODO: swap for a real product screenshot when available.
const ProductMock = () => (
  <div className="mock-wrap" aria-hidden="true">
    <div className="mock">
      <div className="mock-bar">
        <i /><i /><i />
        <span className="mock-url">School ERP · Dashboard</span>
      </div>
      <div className="mock-body">
        <div className="mock-side">
          <span className="on">Dashboard</span>
          <span>Students</span>
          <span>Attendance</span>
          <span>Fees</span>
          <span>Exams</span>
          <span>Messages</span>
        </div>
        <div className="mock-main">
          <div className="mock-title">Good morning, Principal</div>
          <div className="mock-kpis">
            <div className="mock-kpi"><small>Students</small><b>1,248</b></div>
            <div className="mock-kpi"><small>Attendance</small><b>96.4%</b></div>
            <div className="mock-kpi"><small>Fees collected</small><b>₹18.2L</b></div>
          </div>
          <div className="mock-chart">
            {chartBars.map((height, index) => (
              <span key={index} style={{ height: `${height}%`, animationDelay: `${0.6 + index * 0.06}s` }} />
            ))}
          </div>
          <div className="mock-rows">
            <div className="mock-row"><span className="av" />Class 8-B fee reminder sent<span className="pill">Done</span></div>
            <div className="mock-row"><span className="av" />Term 2 results published<span className="pill">Live</span></div>
          </div>
        </div>
      </div>
    </div>
    <motion.div className="mock-float" {...fadeUp(1)}>
      <span className="mock-float-icon"><FiCheckCircle /></span>
      <div>
        <strong>Fee payment received</strong>
        <small>Parent app · just now</small>
      </div>
    </motion.div>
  </div>
);

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-glow" />
      <div className="hero-grid-bg" />

      <div className="container hero-inner">
        <div>
          <motion.div className="hero-badge" {...fadeUp(0)}>
            <span className="hero-badge-dot" />
            Fusion of Digital Management for education
          </motion.div>

          <motion.h1 {...fadeUp(0.08)}>
            Everything digital for your institute, <span className="accent">under one roof.</span>
          </motion.h1>

          <motion.p className="hero-lead" {...fadeUp(0.16)}>
            Fedigma helps schools, colleges, kindergartens, libraries and coaching institutes
            with websites, apps, ERP, digital marketing, content and more, so you can focus on teaching.
          </motion.p>

          <motion.div className="btn-row" {...fadeUp(0.24)}>
            <Link to="/contact" className="btn btn-lg">
              Book a free consultation <FiArrowRight />
            </Link>
            <Link to="/work" className="btn btn-secondary btn-lg">
              See our work
            </Link>
          </motion.div>

          <motion.div className="hero-proof" {...fadeUp(0.32)}>
            {stats.slice(0, 3).map((stat) => (
              <div key={stat.label}>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </motion.div>
        </div>

        <motion.div
          initial={{ y: 32, scale: 0.98 }}
          animate={{ y: 0, scale: 1 }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <ProductMock />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
